export default {
  en: {
    uploader: {
      text: 'Drag & drop your files here or',
      button: 'Select file',
    },
    dropzone: {
      hoverText: 'Drag and drop your documents here to attach them',
    },
    progress: {
      collapse: 'Collapse',
      expand: 'Expand',
      failed: 'Upload failed',
      done: 'Uploaded',
    },
    downloadFailed: 'Failed to download file, contact support for help',
    filesAttached: '{n} file attached | {n} files attached',
    uploadFailed: 'Failed to upload file, contact support for help',
    fileSizeInvalid: 'File is empty or larger than 256 MB.',
    rejected: {
      invalidType:
        "You can't upload this file type: {files} | You can't upload these file types: {files}",
      duplicate:
        "You've already attached a file named {files} | You've already attached files named {files}",
    },
    processing: 'Processing file',
    processingFailed: 'Failed to process file, contact support for help',
  },
};
